var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect, useState } from "react";
import { wait } from "../../../utils/functions/asyncUtils";
export const loadImage = (src) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        if (src) {
            img.src = src;
            img.onload = () => {
                resolve(img);
            };
            img.onerror = (error) => {
                console.error(`Error while retrieving image "${src}"`, error);
                reject(error);
            };
        }
        else {
            reject(new Error("Missing src"));
        }
    });
};
export const useLoadImage = ({ hasInitialError, loadDelay, viewDelay, id, src, load, onLoad, onError, }) => {
    const [{ loaded, hasError }, setState] = useState({
        loaded: hasInitialError,
        hasError: hasInitialError,
    });
    const onMount = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        setState({
            loaded: false,
            hasError: false,
        });
        try {
            yield Promise.all([
                wait(loaded ? 0 : loadDelay)
                    .then(() => loadImage(src))
                    .then((img) => onLoad && onLoad(img)),
                wait(viewDelay),
            ]);
            setState({
                loaded: true,
                hasError: false,
            });
        }
        catch (error) {
            if (onError) {
                onError(error);
            }
            setState({
                loaded: true,
                hasError: true,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [id, loadDelay, onLoad, src, viewDelay]);
    useEffect(() => {
        if (load && src) {
            onMount();
        }
    }, [load, onMount, src]);
    return { loaded, hasError };
};
